/* Progressive enhancement for collection facets.
   Server-side faceting works without JS; this just auto-submits on change and
   syncs the sort dropdown into the filter form so both travel together. */
(function () {
  var form = document.querySelector('[data-facets-form]');
  var sort = document.querySelector('[data-sort]');
  if (!form && !sort) return;

  /* ---- Mobile off-canvas filter panel (M8) ---- */
  var panel = document.querySelector('[data-facets-panel]');
  var toggle = document.querySelector('[data-facets-toggle]');
  var overlay = document.querySelector('[data-facets-close].vlx-facets__overlay') || document.querySelector('.vlx-facets__overlay');
  function openFacets() {
    if (!panel) return;
    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var close = panel.querySelector('[data-facets-close]');
    if (close) close.focus();
  }
  function closeFacets() {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
  }
  if (toggle) toggle.addEventListener('click', openFacets);
  document.querySelectorAll('[data-facets-close]').forEach(function (b) { b.addEventListener('click', closeFacets); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) closeFacets(); });

  function submitFilters() {
    if (!form) return;
    // Remove empty price inputs so they don't add blank params
    form.querySelectorAll('input[type="number"]').forEach(function (i) {
      if (i.value === '') i.disabled = true;
    });
    form.submit();
  }

  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) submitFilters();
    });
    // price: submit on Enter or blur
    form.querySelectorAll('input[type="number"]').forEach(function (i) {
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitFilters(); } });
      i.addEventListener('blur', function () { if (i.value !== '') submitFilters(); });
    });
  }

  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* After a filter/sort reload the context changed (WCAG 3.2.2 / 2.4.3): move
     focus to the results region so keyboard & screen-reader users aren't dumped
     back at the top of the page. */
  var params = new URLSearchParams(window.location.search);
  var filtered = false;
  params.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by') filtered = true; });
  if (filtered) {
    var results = document.getElementById('vlx-results');
    if (results) results.focus();
  }
})();

/* Category chips: open on desktop, collapsed on mobile (reclaims vertical space).
   Driven by the `open` attribute so it works regardless of how the browser hides
   closed <details> content; the markup ships `open`, so without JS chips still show. */
(function () {
  var cats = document.querySelector('[data-cats]');
  if (!cats) return;
  var mq = window.matchMedia('(max-width: 749px)');
  function apply(e) { cats.open = !e.matches; }
  apply(mq);
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
